export default {
      id: "command__key_revoke-usage",
      viewBox: "0 0 92.7 88.2",
      url: __webpack_public_path__ + "img/icons.svg#command__key_revoke",
      toString: function () {
        return this.url;
      }
    }